import { apiClient } from '@/shared/services/client'
import type {
  BusquedasSueroterapia,
  ConfiguracionSueroterapia,
  ConfiguracionSueroterapiaUpdateInput,
  RegistrosPage,
  RegistrosPorDia,
  RegistrosPorProvincia,
  ResumenSueroterapia,
  TestConnectionInput,
  TestConnectionResult,
  VideosSueroterapia,
} from '../types'

const CONFIG_URL = '/sueroterapia/config'
const REPORTES_URL = '/sueroterapia/reportes'

export const sueroterapiaApi = {
  getConfiguracion: async () => {
    const { data } = await apiClient.get<ConfiguracionSueroterapia>(`${CONFIG_URL}/`)
    return data
  },

  saveConfiguracion: async (payload: ConfiguracionSueroterapiaUpdateInput) => {
    const { data } = await apiClient.put<ConfiguracionSueroterapia>(`${CONFIG_URL}/`, payload)
    return data
  },

  testConnection: async (payload?: TestConnectionInput) => {
    const { data } = await apiClient.post<TestConnectionResult>(
      `${CONFIG_URL}/test-connection`,
      payload ?? {},
    )
    return data
  },

  getResumen: async (dias = 90) => {
    const { data } = await apiClient.get<ResumenSueroterapia>(`${REPORTES_URL}/resumen`, {
      params: { dias },
    })
    return data
  },

  getRegistros: async (dias = 90, limit = 100, offset = 0) => {
    const { data } = await apiClient.get<RegistrosPage>(`${REPORTES_URL}/registros`, {
      params: { dias, limit, offset },
    })
    return data
  },

  getRegistrosPorDia: async (dias = 90) => {
    const { data } = await apiClient.get<RegistrosPorDia>(`${REPORTES_URL}/registros-por-dia`, {
      params: { dias },
    })
    return data
  },

  getRegistrosPorProvincia: async (dias = 90) => {
    const { data } = await apiClient.get<RegistrosPorProvincia>(
      `${REPORTES_URL}/registros-por-provincia`,
      { params: { dias } },
    )
    return data
  },

  getBusquedas: async (dias = 90) => {
    const { data } = await apiClient.get<BusquedasSueroterapia>(`${REPORTES_URL}/busquedas`, {
      params: { dias },
    })
    return data
  },

  getVideos: async (dias = 90) => {
    const { data } = await apiClient.get<VideosSueroterapia>(`${REPORTES_URL}/videos`, {
      params: { dias },
    })
    return data
  },
}
